// @flow

import React, { Component } from 'react';
import { LinkedInIcon } from 'seek-style-guide/react';
import { hrefFromLocation } from '@seek/seek-jobs-seo/build/location';
import ShareButton from '../ShareButton/ShareButton';

function linkedInUrl(location) {
  const returnUrl = hrefFromLocation({
    ...location,
    query: {
      ...location.query,
      share: 'li'
    }
  });

  return hrefFromLocation({
    protocol: 'https:',
    hostname: 'www.linkedin.com',
    pathname: '/shareArticle',
    query: {
      mini: true,
      url: returnUrl
    }
  });
}

type Props = {
  location: UrlLocation
};

export default class LinkedInButton extends Component<Props> {
  props: Props;

  render() {
    return (
      <ShareButton
        title="Share on LinkedIn"
        type="linkedin"
        icon={LinkedInIcon}
        href={linkedInUrl(this.props.location)}
        popupWidth={685}
        popupHeight={513}
      />
    );
  }
}
